<app-check-box-pagined [searchSettings]="searchSettings"
                       [loaderId]="loaderId"
                       [totalCount]="totalCount"
                       [filter]="filter"
                       [dataToView]="dataToView"
                       (search)="onSearch($event)"
                       (nextData)="getNextData($event)">
</app-check-box-pagined>